import ApiInstance from "~/api";
import {NexudusBookingCredits, NexudusAllowances} from '~/models/index'

export enum CreditKind {
	DAILYDESK = 'DAILYDESK',
	BOOKINGROOM = 'BOOKINGROOM'
}

const CreditKindValues: Record<CreditKind, string[]> = {
	[CreditKind.DAILYDESK]: ['flexi offer', 'daily pass credit'],
	[CreditKind.BOOKINGROOM]: ['meeting']
};

export const GetBookingCredit = async (creditKind: CreditKind): Promise<string> => {
	let remaining_credits = 0
	const response = await (await ApiInstance.get('/allowances', {cache: false})).data as NexudusAllowances
	const searchValues = CreditKindValues[creditKind];

	if (response && response.BookingCredits) {
		response.BookingCredits.forEach((bookCredit: NexudusBookingCredits) => {
			const creditName = bookCredit.CreditName.toLowerCase().trim();
			const match = searchValues.some(value => creditName.includes(value.toLowerCase().trim()));

			if (match) {
				remaining_credits += bookCredit.RemainingCredit
			}
		})
	}
	let credit;
	if (remaining_credits === 0) {
		console.error('Not valid credit found!')
		credit = '--'
	} else {
		if (creditKind === CreditKind.DAILYDESK) {
			credit = `${remaining_credits / 13} ingressi`
		} else {
			credit = `${remaining_credits} €`
		}
	}
	return credit
}

